import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, ViewEncapsulation, Component } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import * as i2 from 'primeng/badge';
import { BadgeModule } from 'primeng/badge';
const _c0 = (a0, a1) => ({
  "no-icon": a0,
  "selected": a1
});
const _c1 = a0 => ({
  "selected": a0
});
function HeaderMenuItemComponent_ng_container_0_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderMenuItemComponent_ng_container_0_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 6);
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_0_a_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const innerItemTemplate_r1 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r1.itemUrl, i0.ɵɵsanitizeUrl)("target", ctx_r1.itemTarget)("ngClass", i0.ɵɵpureFunction2(4, _c0, !ctx_r1.icon, ctx_r1.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", innerItemTemplate_r1);
  }
}
function HeaderMenuItemComponent_ng_container_0_a_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderMenuItemComponent_ng_container_0_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_0_a_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const innerItemTemplate_r1 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r1.itemRouterLink)("queryParams", ctx_r1.queryParams)("queryParamsHandling", ctx_r1.queryParamsHandling)("target", ctx_r1.itemTarget)("ngClass", i0.ɵɵpureFunction2(6, _c0, !ctx_r1.icon, ctx_r1.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", innerItemTemplate_r1);
  }
}
function HeaderMenuItemComponent_ng_container_0_a_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderMenuItemComponent_ng_container_0_a_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function HeaderMenuItemComponent_ng_container_0_a_3_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMenuItemClick($event));
    });
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_0_a_3_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const innerItemTemplate_r1 = i0.ɵɵreference(5);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c0, !ctx_r1.icon, ctx_r1.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", innerItemTemplate_r1);
  }
}
function HeaderMenuItemComponent_ng_container_0_ng_template_4_i_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 15);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", ctx_r1.iconBadgeValue);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate2("href", "", ctx_r1.icons, "#", ctx_r1.icon, "");
  }
}
function HeaderMenuItemComponent_ng_container_0_ng_template_4_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 17);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate2("href", "", ctx_r1.icons, "#", ctx_r1.icon, "");
  }
}
function HeaderMenuItemComponent_ng_container_0_ng_template_4_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#north-east");
  }
}
function HeaderMenuItemComponent_ng_container_0_ng_template_4_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#chevron-right");
  }
}
function HeaderMenuItemComponent_ng_container_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵtemplate(2, HeaderMenuItemComponent_ng_container_0_ng_template_4_i_2_Template, 3, 4, "i", 12)(3, HeaderMenuItemComponent_ng_container_0_ng_template_4_i_3_Template, 3, 3, "i", 13);
    i0.ɵɵtext(4);
    i0.ɵɵtemplate(5, HeaderMenuItemComponent_ng_container_0_ng_template_4_i_5_Template, 3, 2, "i", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, HeaderMenuItemComponent_ng_container_0_ng_template_4_div_6_Template, 3, 2, "div", 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.icon && ctx_r1.iconBadgeValue);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.icon && !ctx_r1.iconBadgeValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.itemLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showExternalLinkIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showChildItemIcon);
  }
}
function HeaderMenuItemComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_0_a_1_Template, 2, 7, "a", 3)(2, HeaderMenuItemComponent_ng_container_0_a_2_Template, 2, 9, "a", 4)(3, HeaderMenuItemComponent_ng_container_0_a_3_Template, 2, 5, "a", 5)(4, HeaderMenuItemComponent_ng_container_0_ng_template_4_Template, 7, 5, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.itemUrl && !ctx_r1.itemRouterLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.itemRouterLink && !ctx_r1.itemUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isClickEventItem);
  }
}
function HeaderMenuItemComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19)(2, "div", 10)(3, "div", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.itemLabel);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 25);
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_2_a_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const innerItemTitleTemplate_r4 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r1.itemUrl, i0.ɵɵsanitizeUrl)("target", ctx_r1.itemTarget)("ngClass", i0.ɵɵpureFunction1(4, _c1, ctx_r1.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", innerItemTitleTemplate_r4);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_2_a_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const innerItemTitleTemplate_r4 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", ctx_r1.itemRouterLink)("queryParams", ctx_r1.queryParams)("queryParamsHandling", ctx_r1.queryParamsHandling)("target", ctx_r1.itemTarget)("ngClass", i0.ɵɵpureFunction1(6, _c1, ctx_r1.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", innerItemTitleTemplate_r4);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 27);
    i0.ɵɵlistener("click", function HeaderMenuItemComponent_ng_container_2_a_3_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onMenuItemClick($event));
    });
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_2_a_3_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const innerItemTitleTemplate_r4 = i0.ɵɵreference(6);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r1.selected));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", innerItemTitleTemplate_r4);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderMenuItemComponent_ng_container_2_a_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 28);
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_2_a_4_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const innerItemTitleTemplate_r4 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", innerItemTitleTemplate_r4);
  }
}
function HeaderMenuItemComponent_ng_container_2_ng_template_5_i_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#north-east");
  }
}
function HeaderMenuItemComponent_ng_container_2_ng_template_5_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "use");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#chevron-right");
  }
}
function HeaderMenuItemComponent_ng_container_2_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 20);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, HeaderMenuItemComponent_ng_container_2_ng_template_5_i_3_Template, 3, 2, "i", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, HeaderMenuItemComponent_ng_container_2_ng_template_5_div_4_Template, 3, 2, "div", 29);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.itemLabel, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showExternalLinkIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showChildItemIcon);
  }
}
function HeaderMenuItemComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, HeaderMenuItemComponent_ng_container_2_a_1_Template, 2, 6, "a", 21)(2, HeaderMenuItemComponent_ng_container_2_a_2_Template, 2, 8, "a", 22)(3, HeaderMenuItemComponent_ng_container_2_a_3_Template, 2, 4, "a", 23)(4, HeaderMenuItemComponent_ng_container_2_a_4_Template, 2, 1, "a", 24)(5, HeaderMenuItemComponent_ng_container_2_ng_template_5_Template, 5, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.itemUrl && !ctx_r1.itemRouterLink);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.itemRouterLink && !ctx_r1.itemUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isClickEventItem);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.itemRouterLink && !ctx_r1.itemUrl && !ctx_r1.isClickEventItem);
  }
}
function HeaderMenuItemComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 31);
    i0.ɵɵlistener("click", function HeaderMenuItemComponent_ng_container_3_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMenuItemClick($event));
    });
    i0.ɵɵelementStart(2, "div", 10)(3, "div", 32)(4, "i", 33);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 16);
    i0.ɵɵelement(6, "use");
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵattributeInterpolate1("href", "", ctx_r1.icons, "#chevron-left");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.itemLabel, " ");
  }
}
function HeaderMenuItemComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵlistener("click", function HeaderMenuItemComponent_ng_container_4_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMenuItemClick($event));
    });
    i0.ɵɵelementStart(2, "div", 10)(3, "div", 35)(4, "span", 36);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "span", 37);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r1.selected));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.itemLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.itemSubLabel);
  }
}
let HeaderMenuItemComponent = /*#__PURE__*/(() => {
  class HeaderMenuItemComponent {
    constructor() {
      this.icon = '';
      this.iconBadgeValue = '';
      this.itemLabel = '';
      this.showExternalLinkIcon = false;
      this.itemUrl = '';
      this.itemRouterLink = '';
      this.queryParams = {};
      this.queryParamsHandling = '';
      this.itemTarget = '';
      this.showChildItemIcon = false;
      this.isTitleItem = false;
      this.isTitleItemClickable = false;
      this.isPreviousItem = false;
      this.isClickEventItem = false;
      this.isMultilineItem = false;
      this.itemSubLabel = '';
      this.selected = false;
      this.menuItemClick = new EventEmitter();
      this.icons = 'assets/pds-icons.svg';
    }
    onMenuItemClick(event) {
      event.preventDefault();
      this.menuItemClick.emit(event);
    }
    static {
      this.ɵfac = function HeaderMenuItemComponent_Factory(t) {
        return new (t || HeaderMenuItemComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderMenuItemComponent,
        selectors: [["pds-header-menu-item"]],
        inputs: {
          icon: "icon",
          iconBadgeValue: "iconBadgeValue",
          itemLabel: "itemLabel",
          showExternalLinkIcon: "showExternalLinkIcon",
          itemUrl: "itemUrl",
          itemRouterLink: "itemRouterLink",
          queryParams: "queryParams",
          queryParamsHandling: "queryParamsHandling",
          itemTarget: "itemTarget",
          showChildItemIcon: "showChildItemIcon",
          isTitleItem: "isTitleItem",
          isTitleItemClickable: "isTitleItemClickable",
          isPreviousItem: "isPreviousItem",
          isClickEventItem: "isClickEventItem",
          isMultilineItem: "isMultilineItem",
          itemSubLabel: "itemSubLabel",
          selected: "selected"
        },
        outputs: {
          menuItemClick: "menuItemClick"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: ActivatedRoute,
          useValue: {}
        }]), i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 5,
        consts: [["innerItemTemplate", ""], ["innerItemTitleTemplate", ""], [4, "ngIf"], ["class", "pds-header-menu-item", 3, "href", "target", "ngClass", 4, "ngIf"], ["class", "pds-header-menu-item", 3, "routerLink", "queryParams", "queryParamsHandling", "target", "ngClass", 4, "ngIf"], ["class", "pds-header-menu-item", "href", "", 3, "ngClass", "click", 4, "ngIf"], [1, "pds-header-menu-item", 3, "href", "target", "ngClass"], [4, "ngTemplateOutlet"], [1, "pds-header-menu-item", 3, "routerLink", "queryParams", "queryParamsHandling", "target", "ngClass"], ["href", "", 1, "pds-header-menu-item", 3, "click", "ngClass"], [1, "pds-header-menu-item-inner-container"], [1, "pds-header-menu-item-text"], ["class", "pds-header-menu-item-text-icon", "pBadge", "", 3, "value", 4, "ngIf"], ["class", "pds-header-menu-item-text-icon", 4, "ngIf"], ["class", "pds-header-menu-item-icon", "aria-label", "with child items", 4, "ngIf"], ["pBadge", "", 1, "pds-header-menu-item-text-icon", 3, "value"], [1, "pds-icon"], [1, "pds-header-menu-item-text-icon"], ["aria-label", "with child items", 1, "pds-header-menu-item-icon"], ["tabindex", "0", 1, "pds-header-menu-item", "no-clickable"], [1, "pds-header-menu-item-title-text"], ["class", "pds-header-menu-item pds-header-menu-item-clickable", 3, "href", "target", "ngClass", 4, "ngIf"], ["class", "pds-header-menu-item pds-header-menu-item-clickable", 3, "routerLink", "queryParams", "queryParamsHandling", "target", "ngClass", 4, "ngIf"], ["class", "pds-header-menu-item pds-header-menu-item-clickable", "href", "", 3, "ngClass", "click", 4, "ngIf"], ["class", "pds-header-menu-item pds-header-menu-item-clickable no-clickable", 4, "ngIf"], [1, "pds-header-menu-item", "pds-header-menu-item-clickable", 3, "href", "target", "ngClass"], [1, "pds-header-menu-item", "pds-header-menu-item-clickable", 3, "routerLink", "queryParams", "queryParamsHandling", "target", "ngClass"], ["href", "", 1, "pds-header-menu-item", "pds-header-menu-item-clickable", 3, "click", "ngClass"], [1, "pds-header-menu-item", "pds-header-menu-item-clickable", "no-clickable"], ["class", "pds-header-menu-item-icon", 4, "ngIf"], [1, "pds-header-menu-item-icon"], ["tabindex", "0", 1, "pds-header-menu-item", 3, "click"], [1, "pds-header-menu-item-text", "pds-header-menu-item-previous-text"], [1, "pds-header-menu-item-previous-text-icon"], ["tabindex", "0", 1, "pds-header-menu-item", "no-icon", 3, "click", "ngClass"], [1, "pds-header-menu-item-text", "pds-header-menu-item-multiline"], [1, "pds-header-menu-main-item"], [1, "pds-header-menu-item-sub-item"]],
        template: function HeaderMenuItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HeaderMenuItemComponent_ng_container_0_Template, 6, 3, "ng-container", 2)(1, HeaderMenuItemComponent_ng_container_1_Template, 5, 1, "ng-container", 2)(2, HeaderMenuItemComponent_ng_container_2_Template, 7, 4, "ng-container", 2)(3, HeaderMenuItemComponent_ng_container_3_Template, 8, 3, "ng-container", 2)(4, HeaderMenuItemComponent_ng_container_4_Template, 8, 5, "ng-container", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isTitleItem && !ctx.isTitleItemClickable && !ctx.isPreviousItem && !ctx.isMultilineItem);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isTitleItem && !ctx.isTitleItemClickable && !ctx.isPreviousItem && !ctx.isMultilineItem);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isTitleItemClickable && !ctx.isTitleItem && !ctx.isPreviousItem && !ctx.isMultilineItem);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isPreviousItem && !ctx.isTitleItemClickable && !ctx.isTitleItem && !ctx.isMultilineItem);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isMultilineItem && !ctx.isPreviousItem && !ctx.isTitleItem && !ctx.isTitleItemClickable);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, BadgeModule, i2.BadgeDirective, RouterLink],
        encapsulation: 2
      });
    }
  }
  return HeaderMenuItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderMenuItemComponent };
